import React from "react"
import { ErrorPage } from "./ErrorPage"
import { SiteFooter, Logo } from "~/shared-components"
import { css } from "@emotion/react"

export const CrashErrorPage: React.FC = () => {
	return (
		<>
			<div css={headerStyle}>
				<a href="/shop">
					<Logo height={1.875} company={"ncsWhite"} />
				</a>
			</div>
			<ErrorPage
				title="Error"
				description="Whoops, an error has occurred!. You can try refreshing the page and starting again."
			/>
			<SiteFooter />
		</>
	)
}

const headerStyle = css`
	display: flex;
	width: 100%;
	padding: 24px 128px 24px 48px;
	flex-direction: column;
	background: var(--Brand-Deep-Navy, #00264b);
	align-items: flex-start;
`
